module.exports = __webpack_public_path__ + "img/Commodity@2x.a15a4e0b.png";